import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }
}));

// imperatives data start

const ImperativeCard = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [28, 0, 0, 22, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['SRS, 2017']
    },
    2: {
      data: [42, 0, 0, 28, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['SRS, 2017']
    },
    3: {
      data: [46, 0, 0, 22, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['SRS, 2017']
    },
    4: {
      data: [48, 0, 0, 23, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['SRS, 2017']
    },
    5: {
      data: [165, 0, 0, 77, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['SRS, 2014-16']
    },
    6: {
      data: [63,8, 0, 0, 81, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    7: {
      data: [18.3, 0, 0, 0, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['HMIS, 2018-19']
    },
    8: {
      data: [61.7, 0, 0, 90, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-17']
    },
    9: {
      data: [935, 0, 0, 0, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['Census 2011']
    },
    10: {
      data: [12.2, 0, 0, 0, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-17']
    }
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};


const ImperativeCard2 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [63.5, 0, 0, 40, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    2: {
      data: [60.3, 0, 0, 40, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    3: {
      data: [38.7, 0, 0, 30, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['CNNS 2016-18']
    },
    4: {
      data: [14.5, 0, 0, 15, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['CNNS 2016-18']
    },
    5: {
      data: [4.2, 0, 0, 0, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['CNNS 2016-18']
    },
    6: {
      data: [42,8, 0, 0, 30, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['CNNS 2016-18']
    },
    7: {
      data: [53.5, 0, 0, 75, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    8: {
      data: [30.8, 0, 0, 45, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

const ImperativeCard3 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [98.2, 0, 0, 99, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    2: {
      data: [25.2, 0, 0, 40, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
    3: {
      data: [86.3, 0, 0, 95, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['MDW&S, 2016-17']
    },
    
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

const ImperativeCard4 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [0, 0, 0, 0, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['U-DISE, 2016-17']
    },
    2: {
      data: [30.5, 0, 0, 50, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['Census 2011']
    },
    3: {
      data: [40.5, 0, 0, 25, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['Census 2011']
    },
    4: {
      data: [9.53, 0, 0, 7, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['U-DISE, 2016-17']
    },
    5: {
      data: [13.2, 0, 0, 7, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['U-DISE, 2016-17']
    },
    6: {
      data: [33.9, 0, 0, 25, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['Census 2011']
    },
    7: {
      data: [0.82, 0, 0, 1.25, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['U-DISE, 2016-17']
    },
    8: {
      data: [0.21, 0, 0, 0.75, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['U-DISE, 2016-17']
    },
    9: {
      data: [0.09, 0, 0, 0.5, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['U-DISE, 2016-17']
    },
    
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

const ImperativeCard5 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [208, 200, 220, 241, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NAS (Cycle 4)']
    },
    2: {
      data: [235, 205, 225, 241, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NAS (Cycle 4)']
    },
    3: {
      data: [226, 215, 230, 244, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NAS (Cycle 4)']
    },
    
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

const ImperativeCard6 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [42.5, 18, 19, 20, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NFHS-4, 2015-16']
    },
   
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

const ImperativeCard7 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [40,52,480, 1500000, 2000000, 2500000, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['Census 2011']
    },
  
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

const ImperativeCard8 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [3932, 800, 700, 600, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NCRB, 2016'],
    },
    2: {
      data: [2335, 1300, 1110, 1000, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      ds: ['NCRB, 2016']
    },
 
  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      title: `${imperative}  /  ${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
    });
    setExpanded(!expanded);
  };

  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};


const ImperativeCard9 = ({ imperative, outcomes, chartData, setChartData }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const data = {
    1: {
      data: [0, 37, 38, 39, 0, 0, 0],
      labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025' ],
      ds: ['Gazette of Bihar']
      

    },

  };

  

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOutcomeClick = (outcome, index) => {
    setChartData({
      ...chartData,
      // title: `${imperative}  /  ${outcome}`,
      title: `${outcome}`,
      data: data[index + 1].data,
      labels: data[index + 1].labels,
      ds: data[index + 1].ds  
     
      
    });
    setExpanded(!expanded);
  };



// imperatives data end





  return (
    <Card>
      <CardHeader title={imperative} />
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <List>
            {outcomes.map((outcome, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleOutcomeClick(outcome, index)}
              >
                <ListItemText primary={outcome} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default function Imperatives({ chartData, setChartData }) {
  const imperatives = {
    Imperative_1: [
      '1.Neonatal Mortality Rate',
      '2.Infant Mortality Rate',
      '3.Girl Infant Mortality Rate',
      '4.Under Five Mortality Rate',   
      '5.Maternal Mortality Ratio',
      '6.Institutional births (%)', 
      '7.Percentage of home deliveries attended by an SBA (Skilled Birth Attendant)', 
      '8.Children (12-23 months) Fully Immunized (%)',
      '9.Child Sex Ratio',
      '10.Teenage Pregnancy'

    ],
    Imperative_2: [
      'Anaemia among children of age 6-59 months',
      'Anaemia among women of age 15-49 years',
      'Children under 5 years who are underweight (%)',
      'Percentage of Severly Wasted',
      'Children under 5 years who are stunted (%)',
      'Children under age 6 months exclusively breastfed (%)',
    ],
    Imperative_3: [
      'Households with an improved drinking water source (%) ',
      'Households using improved sanitation facility (%) ',
      'Habitations where zero percentage of water sources found contaminated (%)',
      
    ],
    Imperative_4: [
      'Number of out of school children in the age group 6-13 years (taking NER into account)',
      'Percentage of children in the  age group of 15-18 years studying up to secondary level',
      'Percentage of illiterate child among main workers in the age-group of 5-19 years ',
      'Drop-out rate at primary level',
      'Drop-out rate at upper primary level',
      'Percentage of children with disability who never attended educational institutions',
      'Children with Special Needs (CWSN) among children enrolled at elementary level (%)',
      'Children with Special Needs (CWSN) among children enrolled at secondary level (%)',
      'Children with Special Needs (CWSN) among children enrolled at higher secondary level (%)',
    ],
    Imperative_5: [
      'Mean Performance Score in Reading Comprehension of students in Class V ',
      'Mean Performance Score in Mathematics of students in Class V',
      'Mean Performance Score in Environmental Studies of students in Class V',
    ],
    Imperative_6: [
      'Women age 20-24 years married before the age of 18 years (%)',
     
    ],
    Imperative_7: [
      'Number of economically active children in the age-group of 5-19 years',
     
    ],
    Imperative_8: [
      'Cases of crimes against children',
      'Total cognizable crimes committed by children',
    
    ],
    Imperative_9: [
      'No. of officially notified forums (e.g. commissions, committees etc.) constituted at state and district level that include a child representative.',
      
    ],
  };

  return (
    <Grid container spacing={2}>

      {/* {Object.keys(imperatives).map((imperative, index) => ( ))} */}
      
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard
          imperative= {'IMPERATIVE 1: Reducing mortality rates among women and children'}
            outcomes= {imperatives.Imperative_1}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard2
          imperative= {'IMPERATIVE 2 : Breaking the intergenerational cycle of malnutrition'}
            outcomes= {imperatives.Imperative_2}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard3
          imperative= {'IMPERATIVE 3: Improving access of children to safe drinking water and sanitation'}
            outcomes= {imperatives.Imperative_3}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard4
          imperative= {'IMPERATIVE 4: Ensuring universal access of children to continuous education right from pre-school'}
            outcomes= {imperatives.Imperative_4}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard5
          imperative= {'IMPERATIVE 5: Improving quality of education at educational institutions'}
            outcomes= {imperatives.Imperative_5}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard6
          imperative= {'IMPERATIVE 6: Preventing child marriage'}
            outcomes= {imperatives.Imperative_6}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard7
          imperative= {'IMPERATIVE 7: Protecting children from Labour works and economic exploitation '}
            outcomes= {imperatives.Imperative_7}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          <ImperativeCard8
          imperative= {'IMPERATIVE 8: Safeguarding Children in Need of Care & Protection , Reintegration of those in Conflict with Law'}
            outcomes= {imperatives.Imperative_8}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={12} >
          
          <ImperativeCard9
          imperative= {'IMPERATIVE 9: Creating enabling conditions for children to participate'}
            outcomes= {imperatives.Imperative_9}
            chartData={chartData}
            setChartData={setChartData}
          />
        </Grid>
    
    </Grid>
  );
}
